module.exports = __webpack_public_path__ + "prod/20260124143402/img/purpose.cda92bb6.png";